

const lakh_const = 100000
const k_const = 1000



const CommonUtil = {

  getNumberShortner: function(num){
       // console.log("Before number :", num)
	    var newNumber;
	    if(num > lakh_const){
	      newNumber = (num/lakh_const).toFixed(2)
	      newNumber = newNumber + "L"
	    }
	    else if(num > k_const){
	      newNumber = (num/k_const).toFixed(2)
	      newNumber = newNumber + "K"
	    }
	    else{
	      newNumber = num
	    }
	    // console.log("After number :", newNumber)
	    return newNumber
    },

}


export default CommonUtil;
